export const environment = {
  production: false,

  key: 'asdfghjkl1234567890!@#$%^&*()zxc',
  Bank_id: '4kkPALAhxnt+9wQsq+32fg==',
  RBAC_URL: 'http://192.168.83.208:8011/',
  ACS_URL: 'https://isgmv.co.in:9024/rbac-service/',
  apiUrl: 'http://localhost:4000',
  afa_url: '',

  Base_url: 'https://isgmv.co.in:9030/jpmcform/v1/api/',
  isgPayUrl: 'https://pgcloudpoc.insolutionsglobal.com:8464/ISGPay-Genius/request.action',

  //apiUrl: 'http://localhost:4000',
  //Base_url : 'https://isgmv.co.in:9030/cessmodule/v1/api/',
  //Base_url: 'http://192.168.238.36:8500/jpmcform/v1/api/',
  //Base_url : 'https://jpmcforms.insolutionsglobal.com/cessmodule/v1/api/',
  //isgPayUrl: 'https://jpmc.insolutionsglobal.com:8464/ISGPay-Genius/request.action'
  //isgPayUrl: 'https://sandbox.isgpay.com/payments-idbi/request.action',
};